const schemeInfoReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_SCHEME_INFO":
          return state;
      case "SET_SCHEME_INFO" :
          return action.info;
      case "NULL_SCHEME_INFO" :
          return action.info;
      default:
          return state;
    }
  }
  export default schemeInfoReducer
